import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../auth";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useFetchTermsAndConditionsStatus = (entity: "patient" | "therapist" = "patient") => {
  const { api } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.fetchTermsAndConditionsStatus, entity],
    queryFn: () =>
      entity === "therapist" ? api.therapist.getTermsAcceptedStatus() : api.patient.getTermsAcceptedStatus(),
    enabled: isAuthenticated,
  });
};
